import { HELP_URLS } from 'help/constants/URLs'

interface GetAlertLabelProps {
	showDescription: boolean
	alert: string
}

export function getAlertLabel({ showDescription, alert }: GetAlertLabelProps) {
	const text = showDescription
		? `myPurchases.online.details.alert_${alert}.subtitle`
		: `myPurchases.online.alert_${alert}.title`

	return {
		statusMessage: text,
		statusMessagePlaceholders: {
			contactHelp: HELP_URLS.CONTACT,
		},
		isAlert: true,
	}
}
